(function(){
  var STORAGE_KEY = 'rafet_wishlist_v1';

  function getAll(){
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch(e){ return []; }
  }

  function saveAll(items){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch(e){}
  }

  function has(key){
    return getAll().some(function(i){ return i.key === key; });
  }

  function remove(key){
    var items = getAll().filter(function(i){ return i.key !== key; });
    saveAll(items);
    updateBadge();
    return items;
  }

  function add(item){
    var items = getAll();
    if(!items.some(function(i){ return i.key === item.key; })){
      items.push(item);
      saveAll(items);
    }
    updateBadge();
    return items;
  }

  function toggle(btn){
    var key = btn.getAttribute('data-wishlist-key');
    if(!key) return;
    if(has(key)){
      remove(key);
      setButtonState(btn, false);
    } else {
      add({
        key: key,
        title: btn.getAttribute('data-wishlist-title') || '',
        image: btn.getAttribute('data-wishlist-image') || '',
        price: btn.getAttribute('data-wishlist-price') || '',
        url: btn.getAttribute('data-wishlist-url') || '#'
      });
      setButtonState(btn, true);
    }
  }

  function setButtonState(btn, active){
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
  }

  function initButtons(root){
    var scope = root || document;
    var buttons = scope.querySelectorAll('.js-wishlist-btn');
    buttons.forEach(function(btn){
      var key = btn.getAttribute('data-wishlist-key');
      setButtonState(btn, has(key));
    });
  }

  function updateBadge(){
    var count = getAll().length;
    document.querySelectorAll('.js-wishlist-count').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderWishlistPage(){
    var grid = document.getElementById('wishlist-grid');
    if(!grid) return;
    var items = getAll();
    var empty = document.getElementById('wishlist-empty');
    grid.innerHTML = '';
    if(items.length === 0){
      if(empty) empty.style.display = 'block';
      return;
    }
    if(empty) empty.style.display = 'none';
    items.forEach(function(item){
      var card = document.createElement('div');
      card.className = 'vehicle-card';
      card.style.position = 'relative';

      var link = document.createElement('a');
      link.href = item.url || '#';
      link.style.display = 'block';

      if(item.image){
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.style.cssText = 'height:150px;width:100%;object-fit:cover';
        link.appendChild(img);
      } else {
        var ph = document.createElement('div');
        ph.style.cssText = 'height:150px;width:100%;background:#1c1f22;display:flex;align-items:center;justify-content:center;color:#666;font-size:12px;';
        ph.textContent = "Pas d'image";
        link.appendChild(ph);
      }

      var h3 = document.createElement('h3');
      h3.textContent = item.title || '';
      link.appendChild(h3);

      if(item.price){
        var strong = document.createElement('strong');
        strong.textContent = item.price;
        link.appendChild(strong);
      }

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'wishlist-remove-btn';
      var priceNum = null;
              if(item.price){
                        var p = String(item.price);
                                  var isUSD = p.indexOf('$') !== -1;
                                            var numMatch = p.match(/\d[\d,]*\.?\d*/); var n = numMatch ? parseFloat(numMatch[0].replace(/,/g, '')) : NaN;
                                                      if(!isNaN(n)){ priceNum = isUSD ? (n / 0.2723) : n; }
                                                              }
                                                                      if(priceNum !== null){
                                                                                var usdVal = priceNum * 0.2723;
                                                                                          var cfaVal = Math.round(priceNum * 156.91);
                                                                                                    var altSpan = document.createElement('span');
                                                                                                              altSpan.className = 'price-alt-currency';
                                                                                                                        altSpan.style.cssText = 'display:block;font-size:0.75em;color:#6b7280;';
                                                                                                                                  altSpan.textContent = '≈ ' + usdVal.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' USD · ' + cfaVal.toLocaleString('en-US') + ' CFA';
                                                                                                                                            link.appendChild(altSpan);
                                                                                                                                                    }
      removeBtn.setAttribute('data-remove-key', item.key);
      removeBtn.setAttribute('aria-label', 'Retirer des favoris');
      removeBtn.style.cssText = 'position:absolute;top:10px;right:10px;width:30px;height:30px;border-radius:50%;background:rgba(10,12,15,.7);border:1px solid rgba(255,255,255,.25);color:#fff;cursor:pointer;font-size:16px;line-height:1;';
      removeBtn.textContent = '×';

      card.appendChild(link);
      card.appendChild(removeBtn);
      grid.appendChild(card);
    });
  }

  document.addEventListener('click', function(e){
    var likeBtn = e.target.closest('.js-wishlist-btn');
    if(likeBtn){
      e.preventDefault();
      e.stopPropagation();
      toggle(likeBtn);
      renderWishlistPage();
      return;
    }
    var removeBtn = e.target.closest('.wishlist-remove-btn');
    if(removeBtn){
      e.preventDefault();
      e.stopPropagation();
      remove(removeBtn.getAttribute('data-remove-key'));
      initButtons();
      renderWishlistPage();
    }
  });

  function init(){
    initButtons();
    updateBadge();
    renderWishlistPage();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
